<div class="container">
  <div class="loader">
    <div class="inner">
      <img src="../../../assets/images/mytrilo-vertical-icon.svg" class='icon' alt="My" />
    </div>
  </div>
</div>
